import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  login;

  constructor() { }

  loginForm = new FormGroup({
    password: new FormControl("", []),
  });

  ngOnInit() {
    let password = localStorage.getItem('password');
    if (password == 'MSIcommentboard%140!') {
      this.login = true;
    }
  }

  onSubmit() {
    if (this.loginForm.value.password == 'MSIcommentboard%140!') {
      localStorage.setItem('password', 'MSIcommentboard%140!');
      this.login = true;
    }
  }

  logout() {
    this.login = false;
    localStorage.clear();
  }
}
